import { createAction } from '@reduxjs/toolkit';
export const REMOVE_CALL_SESSION = 'REMOVE_CALL_SESSION';
export const removeCallSessionAction = createAction(REMOVE_CALL_SESSION);